import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Button = React.forwardRef(
    ({ children, type, primary, secondary, outline, link, small, className, loading, onClick, formId, disabled, title }, ref) => {
        const classButton = clsx("btn", className, {
            "btn-primary": primary && !outline && !link,
            "btn-secondary": secondary && !outline && !link,
            "btn-outline btn-outline--primary": outline && !secondary,
            "btn-link btn-link--primary": link && !secondary,
            "btn-outline btn-outline--secondary": outline && secondary,
            "btn-link btn-link--secondary": link && secondary,
            "btn-small": small,
            "btn-disabled": disabled,
        });

        const getOnClickHandler = () => {
            if (type === "button" && onClick) {
                return handleOnClick;
            }
            return undefined;
        };

        const handleOnClick = (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (!loading) {
                onClick(event);
            }
        };

        return (
            <button
                ref={ref}
                type={loading ? "button" : type}
                className={classButton}
                onClick={getOnClickHandler()}
                form={formId || undefined}
                disabled={disabled}
                title={title}
            >
                {loading && <div className="icon icon--loading loading" />}
                <span>{children}</span>
            </button>
        );
    }
);

Button.propTypes = {
    children: PropTypes.node,
    primary: PropTypes.bool,
    secondary: PropTypes.bool,
    small: PropTypes.bool,
    type: PropTypes.string,
    onClick: PropTypes.func,
    formId: PropTypes.string,
    disabled: PropTypes.bool,
    title: PropTypes.string,
};

Button.defaultProps = {
    children: "",
    primary: false,
    secondary: false,
    small: false,
    type: "button",
    onClick: undefined,
    formId: undefined,
    disabled: undefined,
    title: undefined,
};

export default Button;
